import { render, staticRenderFns } from "./v_Ongoing_PolygonsMap.vue?vue&type=template&id=6ca4542a&scoped=true&"
import script from "./v_Ongoing_PolygonsMap.vue?vue&type=script&lang=js&"
export * from "./v_Ongoing_PolygonsMap.vue?vue&type=script&lang=js&"
import style0 from "./v_Ongoing_PolygonsMap.vue?vue&type=style&index=0&id=6ca4542a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca4542a",
  null
  
)

export default component.exports